import { CONSTANTS_GENERATION__value_range as CONSTANTS_RANGE } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__fields_by_role } from '@shared/types/types';
import { ENUM__color_compensation } from '../../../_enums/ENUM__color_compensation';
import { ENUM__field_graph_interaction } from '../../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__bool } from '../../../_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__int } from '../../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__string_enum } from '../../../_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { FIELD__tensor_image } from '../../../_fields/_tensor/FIELD__tensor_image';
import { FIELD__tensor_latents } from '../../../_fields/_tensor/FIELD__tensor_latents';
import { ENUM__image_asset_category } from '../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../_fields/image/FIELD__image_asset';
import { FIELD__ml_asset_vae } from '../../../_fields/ml_asset/FIELD__ml_asset_vae';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__field_role } from '../../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_SD__denoise_latents_pipeline } from '../denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__base } from '../INVOCATION_SD__base';

const TILE_SIZE_RANGE = CONSTANTS_RANGE.IMAGE_SIZE_IN.clone({ min: 0 });

export class INVOCATION_SD__image_to_latents extends INVOCATION_SD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_SD__IMAGE_TO_LATENTS;

  /*
   * FIELDS OLD
   */

  /*
   * FIELDS
   */

  @FIELD__image_asset.init_as_input_transform_stretch(
    { category: ENUM__image_asset_category.IMAGE },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE },
  )
  image!: FIELD__image_asset;

  @FIELD__image_asset.init_as_input_transform_stretch(
    { category: ENUM__image_asset_category.MASK },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, ui__has_component: false },
  )
  image_mask!: FIELD__image_asset;

  @FIELD__image_asset.init_as_input_transform_stretch(
    { category: ENUM__image_asset_category.IMAGE },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, data__is_required: false },
  )
  image_under_mask!: FIELD__image_asset;

  @FIELD__ml_asset_vae.init_as_input()
  vae!: FIELD__ml_asset_vae;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: false })
  tiled!: FIELD_PRIMITIVE__bool;

  @FIELD_PRIMITIVE__int.init_as_input({ value: 0, multiple_of: 8, value_range: TILE_SIZE_RANGE, values_allowed: TILE_SIZE_RANGE })
  tile_size!: FIELD_PRIMITIVE__int;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: false })
  fp32!: FIELD_PRIMITIVE__bool;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__color_compensation.NONE, ENUM__color_compensation)
  color_compensation!: FIELD_PRIMITIVE__string_enum;

  /*
   * OUTPUTS
   */

  @FIELD__tensor_latents.init_as_output({}, { field_role: '🔮 Latents Image' })
  out__tensor_latents!: FIELD__tensor_latents;

  @FIELD__tensor_latents.init_as_output({}, { field_role: '🔮 Latents Image Under Mask' })
  out__tensor_latents__under_mask!: FIELD__tensor_latents;

  @FIELD__tensor_image.init_as_output({}, { field_role: '🔢 Tensor Image Mask' })
  out__tensor_image__mask!: FIELD__tensor_image;

  /*
   * EVENTS
   */

  edges__try_autocreate(graph: DTO_GRAPH__instance) {
    super.edges__try_autocreate(graph);

    /*
     * INVOCATION_SD__image_to_latents -> INVOCATION_SD__denoise_latents_base
     */

    this.edges__try_autocreate_from_left_to_right_one_field(graph, INVOCATION_SD__denoise_latents_pipeline, ['latents'], this.out__tensor_latents);
    this.edges__try_autocreate_from_left_to_right_one_field(
      graph,
      INVOCATION_SD__denoise_latents_pipeline,
      ['latents_under_mask'],
      this.out__tensor_latents__under_mask,
    );
    this.edges__try_autocreate_from_left_to_right_one_field(
      graph,
      INVOCATION_SD__denoise_latents_pipeline,
      ['tensor_image__mask'],
      this.out__tensor_image__mask,
    );
  }
  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__IMAGE_TO_LATENTS);
  }

  update_fields_aliases(fields_by_role: MAP__fields_by_role) {
    super.update_fields_aliases(fields_by_role);

    if (this.vae.model.meta.field_role == ENUM__field_role.UNKNOWN) {
      this.vae.model.try_set_field_role(fields_by_role, this.vae.model, ENUM__field_role.MODEL__VAE_ENCODER);
    }
  }
}
